import { useQuery } from 'react-query';
import { getAllSchools } from '../utils/api/salePointApi';
/**
 * Retrieves the collection of available schools we have registered on ibok
 * */
var useListSchools = function () {
    var _a = useQuery('schools', getAllSchools, {
        // The list of schools will from most user's perspective never expire,
        // but use cache of 60 minutes
        staleTime: 3600000,
    }), schools = _a.data, error = _a.error, isLoading = _a.isLoading;
    return {
        schools: schools || { university: [], college: [] },
        error: error !== null && error !== void 0 ? error : undefined,
        isLoading: isLoading,
    };
};
export default useListSchools;
